var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from 'mobx';
import { sortByFunc } from '../../../utils/helper/lodash_replacements';
import { sortedSet } from '../../../utils/mobx/decorators/customComputed';
import { runtime } from '../../../classes/runtime/Runtime';
export class MemorizePointsUnordered {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get remainingWordtasksByInputSimilarity() {
        return this.question.memorizePointsRemaining.remainingWordTasks
            .concat()
            .sort(sortByFunc((wordTask) => wordTask.wordTaskEvaluate.matchSimilarity))
            .reverse();
    }
    get wordtasksForUI() {
        return [...this.question.memorizePointsRemaining.completedWordTasks, ...this.remainingWordtasksByInputSimilarity];
    }
    lastBestMatchingRemainingWordtaskId = '';
    get bestMatchingRemainingWordtask() {
        const [latest] = this.remainingWordtasksByInputSimilarity;
        if (!!latest && latest.id_string !== this.lastBestMatchingRemainingWordtaskId) {
            if (this.lastBestMatchingRemainingWordtaskId) {
                runtime.runtimeScheduler.addToNextIdleStateChange(() => {
                    if (document.activeElement && document.activeElement instanceof HTMLInputElement) {
                        document.activeElement.selectionStart = document.activeElement.selectionEnd = 10000;
                    }
                });
            }
            this.lastBestMatchingRemainingWordtaskId = latest.id_string;
        }
        return latest;
    }
    get areAllRemainingWordtaskWrongWithCurrentInput() {
        return !this.question.memorizePointsRemaining.remainingWordTasks
            .map(wordTask => wordTask.wordTaskEvaluate.isWrongToCurrentInput)
            .includes(false);
    }
    assignChangeEventToBestMatching(e) {
        this.question.memorizePointsRemaining.remainingWordTasks.forEach(wordTask => {
            wordTask.wordTaskInput.inputValueHidden = e.target.value;
        });
        const bestMatching = this.bestMatchingRemainingWordtask;
        bestMatching.wordTaskForm.focusInputField();
    }
}
__decorate([
    sortedSet
], MemorizePointsUnordered.prototype, "remainingWordtasksByInputSimilarity", null);
